export default __webpack_public_path__ + "6ac853d91721857ac728d1eb6d6aa75d.png";